import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Well } from '../../../components/Well';
import { WS1_4_TestDrive } from '../../KanbanBoards/cells/WS/WS1_4_TestDrive';
import { WS2_1_Interior } from '../../KanbanBoards/cells/WS/WS2_1_Interior';
import { WS2_6_InteriorPictures } from '../../KanbanBoards/cells/WS/WS2_6_InteriorPictures';
import { SetActionStateButton01 } from '../components/SetActionStateButton01';
import { SetActionStateButton0123 } from '../components/SetActionStateButton0123';
import { SetActionStateButtonCustom } from '../components/SetActionStateButtonCustom';

const Container = styled.div`
  h2 {
    font-size: 16px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleDetailsStateComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  get vehicle() {
    return this.props.vehicle;
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  render() {
    const vehicle = this.vehicle;
    console.dir(vehicle);
    return (
      <Container>
        <h2>Algemeen</h2>
        <SetActionStateButton01 vehicle={vehicle} propertyName="active_claim" />
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_final_inspection" />
        <h2>WS2</h2>
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_interior_pictures" />
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_exterior_inspection" />
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_exterior_pictures" />
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_attach_replate" />
        <hr />
        <h2>WS3</h2>
        <SetActionStateButton01 vehicle={vehicle} propertyName="ws3_lock" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_interior_pictures" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_polish_exterior" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_int_ext_polish" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_adjust" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_desticker" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_service" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_apk" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_recall" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_window_repair" />
        <SetActionStateButton0123 vehicle={vehicle} propertyName="task_repair" />
        <h2>ADM_IN</h2>
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_purchase_release" />
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_import_papers" />
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_individual_takein" />
        <SetActionStateButton01 vehicle={vehicle} propertyName="task_rdw_sample" />
        <h2>ADM_OUT</h2>
        {[
          'task_adm_out_0_enable',
          'task_adm_out_1_cancel_exports',
          'task_adm_out_2_export_plates',
          'task_adm_out_3_german_letter',
          'task_adm_out_4_move_to_weeze',
          'task_adm_out_5_sales_release',
        ].map(name => (
          <SetActionStateButton01 key={name} vehicle={vehicle} propertyName={name} />
        ))}
        <h2>Proefrit</h2>
        <HBox left>
          <SetActionStateButtonCustom
            setOn
            vehicle={vehicle}
            active={vehicle.task_test_drive === '1' && !vehicle.task_test_drive_complete}
            properties={{
              task_test_drive: '1',
              task_test_drive_complete: null,
            }}
          />

          <SetActionStateButtonCustom
            setOff
            vehicle={vehicle}
            active={!vehicle.task_test_drive || vehicle.task_test_drive_complete}
            properties={{
              task_test_drive: '0',
              task_test_drive_complete: '1',
            }}
          />
        </HBox>
        <h2>Voor inspectie</h2>
        {vehicle.active_claim === '1' ? <Well alert>Let op! active_claim</Well> : null}
        <HBox left>
          <SetActionStateButtonCustom
            setOn
            vehicle={vehicle}
            active={vehicle.action_ws1_preinspection_done === '1'}
            properties={{
              action_ws1_preinspection_done: '1',
            }}
          />

          <SetActionStateButtonCustom
            setOff
            vehicle={vehicle}
            active={vehicle.action_ws1_preinspection_done === '0'}
            properties={{
              action_ws1_preinspection_done: '0',
            }}
          />
        </HBox>
      </Container>
    );
  }
}

VehicleDetailsStateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const VehicleDetailsState = compose(
  withConnect,
  withRouter,
)(VehicleDetailsStateComp);
